import { Component, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NzIconService } from 'ng-zorro-antd/icon';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router, ActivatedRoute, ActivationEnd, ParamMap, } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { PermissionToolkitService, StorageService } from 'front-common-toolkits';
import { en_US, NzI18nService, zh_CN } from "ng-zorro-antd/i18n";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { environment } from "../../../../environments/environment";
import { TenantSelectorComponent } from "../../../components/tools/tenant-selector/tenant-selector.component";
import { AuthenticationService } from "../../../services/utils/authentication.service";
import { TenantUserService } from "../../../pages/tenant/services/tenant-user.service";
import { TenantRoleService } from 'src/app/pages/admin/services/tenant-role.service';
import { Store } from "@ngrx/store";
import { AppState } from "src/app/services/state/app.state";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as CryptoJS from 'crypto-js';
import { filter, map, mergeMap, startWith } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { TenantMenuService } from 'src/app/pages/admin/services/tenant-menu.service';

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss'],
  providers: [AuthenticationService]
})
export class TopNavComponent implements OnInit, OnDestroy {
  @ViewChild('tenantSelector') tenantSelector: TenantSelectorComponent;
  isCollapsed = false;
  @Input() isShowSystemInfo = true;
  validateForm: FormGroup;
  tenantLoginForm: FormGroup;
  pwdLoginForm: FormGroup;
  tenantUser: any = {};
  isSmsCodeSent = false;

  currentModule: any = {};
  modules;
  currentUser;
  currentTenant;
  loginType: 'tenant' | 'admin' = environment.isAdmin ? 'admin' : 'tenant';
  showPopup = false;
  tmpUrl
  currentUrl
  availableSubSystems
  constructor(
    private permissionServices: PermissionToolkitService,
    private fb: FormBuilder,
    private permissionToolkitService: PermissionToolkitService,
    private authenticationService: AuthenticationService,
    public translateService: TranslateService,
    private tenantUserService: TenantUserService,
    public nzI18nService: NzI18nService,
    private router: Router,
    private route: ActivatedRoute,
    private activateRoute: ActivatedRoute,
    private modalService: NzModalService,
    private notification: NzNotificationService,
    private cookieService: CookieService,
    private iconService: NzIconService,
    private storageService: StorageService,
    private tenantRoleService: TenantRoleService,
    private menuService: TenantMenuService,
    private store: Store<AppState>,
  ) {
    store.select("user").subscribe(o => {
      this.currentUser = o;
    })

    this.iconService.fetchFromIconfont({
      scriptUrl: environment.ICON_FONT_URL
    });
    let defaultLang = 'zh';
    let local = zh_CN;
    if (localStorage.getItem('defaultLang')) {
      defaultLang = localStorage.getItem('defaultLang');
    }

    /* --- set i18n begin ---*/
    this.translateService.addLangs(['zh', 'en', 'ja']);
    this.translateService.setDefaultLang(defaultLang);
    // const browserLang = this.translateService.getBrowserLang();
    this.translateService.use(defaultLang);

    switch (defaultLang) {
      case 'en': { local = en_US; break; }
      case 'zh': { local = zh_CN; break; }
      // case 'ja': { local = ja_JP; break; }
      default: local = en_US;
    }
    this.nzI18nService.setLocale(local);
    /* --- set i18n end ---*/
    this.currentModule = this.storageService.getLocalItem('currentModule');
    const defaultTheme = this.storageService.getLocalItem('defaultTheme');
    if (defaultTheme) {
      this.changeTheme(defaultTheme);
    }

    // 让模块切换的时候重载页面
    // override the route reuse strategy
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });

    const tenant = this.storageService.getLocalItem('currentTenant');
    if (tenant) {
      this.currentTenant = tenant;
    }

    this.tenantLoginForm = this.fb.group({
      mobile: [null, [Validators.required]],
      oldPassword: [null],
      password: [null, [Validators.required]],
      confirmPassword: [null],
      smsCode: [null, [Validators.required]]
    });
    this.tenantUser['mobile'] = this.currentUser.userMobile;

    // 监听路由事件 // 只订阅 ActivationEnd 事件
    // this.router.events.pipe(
    //   filter(e => e instanceof ActivationEnd),
    //   map(() => this.activateRoute),
    //   map(route => {
    //     while (route.firstChild) {
    //       route = route.firstChild;
    //     }
    //     this.tmpUrl =this.getResolvedUrl(route.snapshot) 
    //     console.log('tmpUrl', this.tmpUrl)
    //     return route;
    //   }),
    //   mergeMap(route => route.data)
    // )
    //   .subscribe((e: ActivationEnd) => {
    //     console.log('e', e)
    //     const url = this.router.url;
    //     console.log('this.router', this.router)

    //     // 获取路由配置中自定义的唯一标记
    //     const path = this.tmpUrl;
    //     this.currentUrl = path
    //     // //截取父path
    //     this.parentUrl = this.currentUrl.replace("/" + this.currentUrl.split("/")[this.currentUrl.split("/").length - 1], "")
    //     console.log('this.parentUrl', this.parentUrl)
    //   })
  }
  currMenu: any = [];
  parentUrl
  async ngOnInit() {
    // this.tokenRefresh();
    // this.currMenu = this.route.snapshot.firstChild.data.crumb || this.currMenu
    // console.log('currMenu',this.route)
    await this.listenRouterchange()
    // await this.loadTenantMenus();
  }
  // async loadTenantMenus(){
  //   this.availableSubSystems = await this.menuService.getTenantMenus().toPromise()
  // }
  //20220412 baij 修复 PC端-【左侧菜单栏】-涉及到有子菜单的功能模块，权限未开通时，点击主菜单会退出系统并提示“没有此访问权限”
  getResolvedUrl(route): string {
    return route.pathFromRoot
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .filter(d => d)
      .join('/');
  }
  // 生成动态面包屑 
  // async listenRouterchange() {
  //   this.router.events.pipe(
  //     filter(e => e instanceof ActivationEnd),
  //     map(() => this.activateRoute),
  //     map(route => {
  //       while (route.firstChild) {
  //         route = route.firstChild;
  //       }
  //       this.tmpUrl =this.getResolvedUrl(route.snapshot)
  //       console.log('tmpUrl', this.tmpUrl)
  //       return route;
  //     }),
  //     mergeMap(route => route.data)
  //   )


  async listenRouterchange() {
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      startWith(true),
      map(() => this.activateRoute),
      // map(route => {
      //   while (route.firstChild) {
      //     route = route.firstChild;
      //   }
      //   this.tmpUrl =this.getResolvedUrl(route.snapshot)
      //   console.log('tmpUrl', this.tmpUrl)
      //   return route;
      // }),
      mergeMap(route => route.data)
    )
      .subscribe((res: ActivationEnd) => {
        this.route.queryParamMap.subscribe((params: ParamMap) => {
         
          const state = this.router.routerState
          const parent = state.root
          this.currMenu = this.getCrumb(state, parent,params)
        });
      })
  }

  getCrumb(state, parent,params) {

    const data = []
    if (parent && parent.snapshot.data && parent.snapshot.data.breadcrumb) {
      this.tmpUrl = '/' + this.getResolvedUrl(parent.snapshot)
      if (this.tmpUrl==params.get('url')){
        data.push({ path: this.tmpUrl, name: parent.snapshot.data.breadcrumb +'-'+params.get('breadcrumbName')})
      }else{
        data.push({ path: this.tmpUrl, name: parent.snapshot.data.breadcrumb})
      }
      
    }
    if (state && parent) {
      data.push(...this.getCrumb(state, state.firstChild(parent),params));
    }
    return data;

  }

  ngOnDestroy(): void {
    // clearInterval(window['refreshTokenInterval']);
  }

  // tokenRefresh() {
  //   window['refreshTokenInterval'] = setInterval(() => {
  //     this.authenticationService.refreshToken();
  //   }, 60000);
  // }

  switchLanguage(lang) {
    this.translateService.setDefaultLang(lang);
    this.translateService.use(lang);
    localStorage.setItem('defaultLang', lang);
    switch (lang) {
      case 'en': {
        this.nzI18nService.setLocale(en_US);
        break;
      }
      case 'zh': {
        this.nzI18nService.setLocale(zh_CN);
        break;
      }
      default:
        this.nzI18nService.setLocale(en_US);
    }
  }

  logout() {
    const labelLogout = this.translateService.instant('登出系统');
    const labelLogoutConfirm = this.translateService.instant('确定登出系统吗？');
    this.modalService.create({
      nzTitle: labelLogout,
      nzContent: labelLogoutConfirm,
      nzOnOk: () => {
        this.cookieService.delete('token');
        this.cookieService.delete('refreshToken');
        this.router.navigate(['/login']);
        this.cookieService.delete('tenantLoginResult'); //20211224 baij  退出登录后会回到选择企业页面，应该是回到登录首页
        this.cookieService.deleteAll;
        sessionStorage.removeItem('halo-menu')    //20220211  baij 将数据放到缓存中 当用户退出清理缓存
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('refreshToken');
        this.storageService.removeLocalItem('token');
        this.storageService.removeLocalItem('refreshToken');
      }
    });
  }

  onBusinessTypeChange(event) {
    this.resetBusinessType(event);
  }

  resetBusinessType(newBusinessType) {
    this.storageService.setBusinessTypeItem(newBusinessType);
    window.location.reload();
  }

  changeTheme(theme: 'default' | 'dark' | 'light'): void {
    // if (theme !== 'default') {
    //   const style = document.createElement('link');
    //   style.type = 'text/css';
    //   style.rel = 'stylesheet';
    //   style.id = theme + '-theme';
    //   style.href = './assets/themes/style.' + theme + '.css';
    //   document.body.appendChild(style);
    //
    // } else {
    //   const dom = document.getElementById('dark-theme');
    //   if (dom) {
    //     dom.remove();
    //   }
    //   const dom2 = document.getElementById('light-theme');
    //   if (dom2) {
    //     dom2.remove();
    //   }
    // }
    // this.storageService.setLocalItem('defaultTheme', theme);
  }
  //密码修改
  showPassword = false
  updatePassword() {
    this.showPassword = true
  }

  //取消
  cancel() {

    this.showPassword = false
    this.tenantLoginForm.reset();
    for (const key in this.tenantLoginForm.controls) {
      if (this.tenantLoginForm.controls.hasOwnProperty(key)) {
        this.tenantLoginForm.controls[key].markAsPristine();
        this.tenantLoginForm.controls[key].updateValueAndValidity();
      }
    }
    this.tenantUser['mobile'] = this.currentUser.userMobile;
  }
  error = '';
  sendSmsCode() {
    if (this.tenantUser.mobile) {
      this.error = '';
      //正则校验
      var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (!reg_tel.test(this.tenantUser.mobile)) {
        this.error = '请输入数字或11位数字';
        console.log(this.error)
        return false;
      }
      this.authenticationService.getSmsCode(this.tenantUser.mobile).subscribe(res => {
        if (res['code'] === 0) {
          this.setSmsColdDown()
        }
      })
    } else {
      this.error = '请输入合法的手机号码';
    }
  }
  hintMessage;
  countDownNum: number = 60;
  setSmsColdDown() {
    if (window['setSmsColdDownInterval']) {
      this.hintMessage = '验证码已发送, 请在' + this.countDownNum + '秒后重试';
    } else {
      this.isSmsCodeSent = true;
      window['setSmsColdDownInterval'] = setInterval(() => {
        this.countDownNum -= 1;
        if (this.countDownNum === 0) {
          this.isSmsCodeSent = false;
          this.countDownNum = 60;
          clearInterval(window['setSmsColdDownInterval']);
        }
      }, 1000);
    }
  }
  tenantLogin() {
    let param: any = {};
    if (this.loginType==='tenant'){
      if (!this.tenantLoginForm.valid) {
        if (this.tenantLoginForm.controls.mobile.status === 'INVALID' ||
          this.tenantLoginForm.controls.password.status === 'INVALID') {
          this.error = '用户名或密码错误';
        } else if (this.tenantLoginForm.controls.smsCode.status === 'INVALID') {
          this.error = '请输入短信验证码';
        }
        return;
      }
    }else{
      this.tenantUser['mobile'] = 11111111111;
      this.tenantUser['smsCode'] = 111111;
      if (!this.tenantUser.oldPassword){
        this.error = '请输入原密码';
        return;
      }
      if (!this.tenantUser.password || !this.tenantUser.confirmPassword){
        this.error = '请输入新密码';
        return;
      }
      if (this.tenantUser.password !== this.tenantUser.confirmPassword){
        this.error = '新密码输入不一致';
        return;
      }
    }
    
    const oldPwd = CryptoJS.SHA256(this.tenantUser.oldPassword).toString();
    const newPwd = CryptoJS.SHA256(this.tenantUser.password).toString();

    param = { mobile: this.tenantUser['mobile'], oldPwd: oldPwd, newPwd: newPwd, smsCode: this.tenantUser['smsCode'] }
    this.error = undefined;
    this.authenticationService.pwd(param)
      .subscribe(async (result: any) => {
        if (result) {
          if (this.loginType==='tenant' && result.data && result.code == 0) {
            this.notification.create(
              'success', '修改结果', '账号密码修改成功！',
            );

          }else if (this.loginType==='admin' && result.code == 0) {
            this.notification.create(
              'success', '修改结果', '账号密码修改成功！',
            );

          }  else {
            this.notification.create(
              'error', '修改结果', result.message,
            );
          }
          this.cancel()
        } else {
          this.error = '登录信息错误';
          this.notification.create(
            'error', '修改结果', '登录信息错误',
          );
          this.tenantUser = {
            mobile: '',
            smsCode: '',
            oldPassword: '',
            password: '',
            confirmPassword: ''
          }
          this.showPassword = false
        }
      }, err => {
      });

  }
  //取出输入参数最后一个参数 /分割
  // getUrlParam(path) {
  //   let url = path;
  //   let param = url.split('/');
  //   return param[param.length - 1];
  // }
  // PC端-【左侧菜单栏】-涉及到有子菜单的功能模块，权限未开通时，点击主菜单会退出系统并提示“没有此访问权限”
  // async canActive(index) {
    // let result = false;
    // if (this.availableSubSystems) {
    //   this.availableSubSystems.forEach(subSys => {
    //     if (subSys.menuUrl?.includes(this.getUrlParam(item.path))) {
    //       result = true;
    //     }
    //   })
    // } 
    // return result
  // }

}
